import { NgModule } from '@angular/core'
import {
  ButtonComponent,
  ButtonModule,
  IconButtonComponent,
} from '@vg-constellation/angular-16/button'
import {
  CheckboxComponent,
  CheckboxGroupComponent,
  CheckboxInputComponent,
} from '@vg-constellation/angular-16/checkbox'
import { ChipModule } from '@vg-constellation/angular-16/chip'
import { HintErrorModule } from '@vg-constellation/angular-16/hint-error'
import { IconComponent, IconModule } from '@vg-constellation/angular-16/icon'
import { InputModule } from '@vg-constellation/angular-16/input'
import { LabelModule } from '@vg-constellation/angular-16/label'
import { LinkModule } from '@vg-constellation/angular-16/link'
import {
  ModalDialogComponent,
  ModalDialogModule,
} from '@vg-constellation/angular-16/modal-dialog'
import { PaginationModule } from '@vg-constellation/angular-16/pagination'
import { RadioModule } from '@vg-constellation/angular-16/radio'
import { SearchModule } from '@vg-constellation/angular-16/search'
import {
  SelectComponent,
  SelectInputComponent,
  SelectModule,
} from '@vg-constellation/angular-16/select'
import {
  SpinnerComponent,
  SpinnerModule,
} from '@vg-constellation/angular-16/spinner'
import { StepIndicatorModule } from '@vg-constellation/angular-16/step-indicator'
import { SwitchModule } from '@vg-constellation/angular-16/switch'
import { TabsModule } from '@vg-constellation/angular-16/tabs'
import {
  TooltipComponent,
  TooltipContentDirective,
} from '@vg-constellation/angular-16/tooltip'

const c11nModule = [
  ButtonModule,
  ButtonComponent,
  CheckboxComponent,
  CheckboxInputComponent,
  CheckboxGroupComponent,
  ChipModule,
  HintErrorModule,
  IconButtonComponent,
  IconComponent,
  IconModule,
  InputModule,
  LabelModule,
  LinkModule,
  ModalDialogComponent,
  ModalDialogModule,
  ModalDialogModule.forRoot(),
  PaginationModule,
  RadioModule,
  SelectComponent,
  SelectInputComponent,
  SelectModule,
  SpinnerComponent,
  SpinnerModule,
  StepIndicatorModule,
  SwitchModule,
  TabsModule,
  TooltipComponent,
  TooltipContentDirective,
  SearchModule,
]

@NgModule({
  declarations: [],
  imports: [c11nModule],
  exports: [c11nModule],
})
export class VgConstellationModule {}
